import {
  computeItemIdentifier,
  Configuration,
} from '@o3r/core';
import {
  COMPONENTS_CONFIGURATION_NAME,
} from '../../../configuration/index';

/**
 * Servicing recovery configuration
 *
 * @title Servicing recovery
 */
export interface RecoveryConfig extends Configuration {
  /**
   * Key used to identify a custom component if provided
   *
   * @o3rCategory technical
   */
  backToMmbCustomComponentKey: string;

  /**
   * Whether to show the manage my booking button or not in recovery page
   *
   * @o3rCategory display
   */
  showBackToMmbButton: boolean;

  /**
   * Whether to show the refund teaser or not in recovery page
   *
   * @o3rCategory display
   */
  showRefundTeaser: boolean;

  /**
   * Whether to show the retrieve my booking button or not in recovery page
   *
   * @o3rCategory display
   */
  showRetrieveBookingButton: boolean;
}

export const RECOVERY_DEFAULT_CONFIG: RecoveryConfig = {
  backToMmbCustomComponentKey: '',
  showBackToMmbButton: false,
  showRefundTeaser: false,
  showRetrieveBookingButton: true
};

export const RECOVERY_CONFIG_ID = computeItemIdentifier('RecoveryConfig', COMPONENTS_CONFIGURATION_NAME);
